module.exports = __webpack_public_path__ + "static/AR2-9fbeb7074e8594e47430dcb0efe866b2.png";